import { createReducer } from '@reduxjs/toolkit';
import { ClientDto } from '../../api/ClientApi';

import { saveClient, importClients, addClientToRedux } from '../actions/clientActions';

export interface ClientsState {
    clients: ClientDto[] | null;
}

export const clientsReducer = createReducer<ClientsState>({ clients: null }, (builder) => {
    builder
        .addCase(addClientToRedux, (state: ClientsState, action: any) => {
            if (state.clients === null) {
                return;
            }

            const payload: ClientDto = action.payload;

            const client: ClientDto = new ClientDto();
            client.init(payload);

            if (!state.clients) {
                state.clients = [client];
            } else {
                // add client
                state.clients.unshift(client);
            }
        })
        .addCase(saveClient.fulfilled, (state: ClientsState, action: any) => {
            if (state.clients === null) {
                return;
            }

            const payload: ClientDto = action.payload;

            const client: ClientDto = new ClientDto();
            client.init(payload);

            const clientIndex = state.clients!.findIndex((a) => {
                return a.id === client.id;
            });

            if (clientIndex >= 0) {
                // update client
                state.clients.splice(clientIndex, 1, client);
            } else {
                // add client
                state.clients.unshift(client);
            }
        })
        .addCase(importClients.fulfilled, (state: ClientsState, action: any) => {
            const newClients = action.payload as ClientDto[];

            state.clients = newClients.sort((a, b) => (b.id ?? 0) - (a.id ?? 0));
        });
});
